// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"ab57862a","951":"7d993055"}[chunkId] + ".chunk.css";
};